module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeAQMAAAAB/jzhAAAAA1BMVEX/TwBuA1r9AAAAC0lEQVQIHWMYlAAAAJYAAVsU5FsAAAAASUVORK5CYII="